import React, { FC, useMemo } from 'react'
import { createUseStyles } from 'react-jss'
import { useCurrentUserProfile } from '../../../../common/hooks/database/use-current-user-profile'
import { useTutorRegistrations } from '../../../../common/hooks/database/use-tutor-registrations'
import { getNow } from '../../../../common/logic/date-logic'
import { chunkRegistrationsByWeek } from '../../../../common/utils/database/chunk-registrations-by-week'
import { HomeSection } from '../../../home-section/HomeSection'
import { RegistrationsforWeekSection } from '../registrations-for-week-section/RegistrationsforWeekSection'

type TutorMySessionsSectionProps = {}

export const TutorMySessionsSection: FC<TutorMySessionsSectionProps> = () => {

	// hooks
	const styles = useStyles()
	const { isTutor } = useCurrentUserProfile()
	const registrations = useTutorRegistrations()
	const registrationsByWeek = useMemo(() => chunkRegistrationsByWeek(registrations), [registrations])
	const registrationWeeks = useMemo(() => registrationsByWeek ? Object.keys(registrationsByWeek).map(date => parseInt(date)) : undefined, [registrationsByWeek])
	const defaultTitle = useMemo(() => `My Sessions this Week (${getNow().startOf('week').add(1, 'week').format('dddd MMM, D')})`, [])

	if (!isTutor) {
		return null
	}

	return (
		<div className={styles.tutorMySessionsSection}>
			{registrationsByWeek && registrationWeeks?.map(registrationWeek => (
				<RegistrationsforWeekSection key={registrationWeek} week={registrationWeek} registrations={registrationsByWeek[registrationWeek]} />
			))}
			{registrationWeeks && registrationWeeks?.length < 1 && (
				<HomeSection title={defaultTitle} helpText="Showing sessions that you have scheduled for this week.">
					{/* <span className={styles.infoText}>No students have registered for sessions with you this week.</span> */}
				</HomeSection>
			)}
		</div>
	)
}

const useStyles = createUseStyles({
	tutorMySessionsSection: {
		display: 'grid',
		gap: 24,
		gridTemplateRows: 'max-content',
	},
	infoText: {
		fontStyle: 'italic',
		fontSize: 12,
	},
})